namespace $.$$ {
	/** Compatibility host for existing token widgets. Account logic lives in Applications. */
	export class $shm_hitalama_vk_token_switch extends $.$shm_hitalama_vk_token_switch {
		fqn() { return '$' + 'shm2_vk_account' }
		current(): $shm_hitalama_vk_token | null { return ( this.instance() as any ).current() }
	}
}
